module.exports = __webpack_public_path__ + "static/img/loginBg.2e86c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/loginBg.png
// module id = U05m
// module chunks = 44